<template>
    <section>
        <b-loading :is-full-page="true" v-model="loading" :can-cancel="true"></b-loading>

        <b-table :data="updates"

                 hoverable
                 bordered

                 narrowed
                 paginated
        >
            <b-table-column field="name" label="Тип обновления" centered>
                <template v-slot="props">
                    {{ translateUpdateType(props.row.type) }}
                </template>
            </b-table-column>

            <b-table-column field="description" label="Статус" centered>
                <template v-slot="props">
                    <template v-if="props.row.in_progress">
                        Обновляется
                        <br>
                        (началось: <b>{{ toLocalTime(props.row.last_started_at) | moment("from", "now") }}</b> в {{ toLocalTime(props.row.last_started_at) }})
                    </template>
                    <template v-else>
                        Обновлено
                        <br>
                        (закончилось: <b>{{ toLocalTime(props.row.last_ended_at) | moment("from", "now") }}</b> в {{ toLocalTime(props.row.last_ended_at) }})
                    </template>
                </template>
            </b-table-column>

            <b-table-column field="description" label="Последнее обновление" centered>
                <template v-slot="props">
                    <b-tag v-if="props.row.is_last_error" type="is-danger">Ошибка</b-tag>
                    <b-tag v-else type="is-success">Успешно</b-tag>
                </template>
            </b-table-column>

            <b-table-column field="edit" label="Действия" centered>
                <template v-slot="props">
                    <div class="buttons">
                        <b-button type="is-primary" icon-right="refresh"
                                  @click="run(props.row.type)"
                        />
                    </div>
                </template>
            </b-table-column>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                    icon="emoticon-frown-outline"
                                    size="is-large"
                            />
                        </p>
                        <p>Записи отсутствуют</p>
                    </div>
                </section>
            </template>
        </b-table>
    </section>
</template>

<script>
import updateRepository from "../../repository/updateRepository";

export default {
    data() {
        return {
            loading: false,
            updates: [],
            typeNames: {
                'combo': 'Комбо',
                'nomenclature': 'Меню',
                'delivery_restrictions': 'Режим работы и Параметры доставки',
                'payment_types': 'Типы платежей',
                'stop_list': 'Стоп-лист',
                'streets': 'Улицы',
                'customer_categories': 'Категории пользователей',
            }
        }
    },
    methods: {
        fetchData() {
            this.loading = true;

            return updateRepository.all()
                .then(({data}) => {
                    this.updates = data
                })
                .then(() => this.$buefy.toast.open('Обновления загружены'))
                .catch(() => this.$buefy.toast.open('Ошибка при загрузке обновлений'))
                .finally(() => {
                    this.loading = false
                })
        },
        run(type) {
            this.loading = true;

            updateRepository.run(type)
                .then(() => this.$buefy.toast.open('Обновление завершено'))
                .then(() => this.fetchData())
                .catch(() => this.$buefy.toast.open('Ошибка при запуске обновления'))
                .finally(() => {
                    this.loading = false
                })
        },
        translateUpdateType(type) {
            return this.typeNames[type] ?? type;
        },
        toLocalTime(dateTime) {
            return this.$moment.utc(dateTime).local().format('YYYY-MM-DD HH:mm:ss');
        },
    },
    mounted() {
        this.fetchData();
    }
}
</script>

<style scoped>

</style>
